<footer class="site-footer">
  <div class="footer-main">
    <div class="footer-inner">

      <!-- Column 1: Brand -->
      <div class="footer-col footer-brand">
        <img src="assets/images/logo.png" alt="Kontakta" class="footer-logo" width="155" height="51" />
        <p class="footer-tagline">{{ 'footer.tagline' | translate }}</p>
        <div class="footer-socials">
          <a href="https://www.facebook.com/Kontakta24" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Facebook">
            <i class="fa-brands fa-facebook"></i>
          </a>
          <a href="https://twitter.com/kontakta_bg" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Twitter">
            <i class="fa-brands fa-twitter"></i>
          </a>
          <a href="https://www.instagram.com/kontakta_dugme_spasa" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Instagram">
            <i class="fa-brands fa-instagram"></i>
          </a>
        </div>
      </div>

      <!-- Column 2: Navigation -->
      <div class="footer-col">
        <h2 class="footer-heading">{{ 'footer.nav.title' | translate }}</h2>
        <ul class="footer-links">
          <li><a routerLink="/">{{ 'header.home' | translate }}</a></li>
          <li><a routerLink="/about">{{ 'header.about' | translate }}</a></li>
          <li><a routerLink="/services">{{ 'header.services.civilians' | translate }}</a></li>
          <li><a routerLink="/work-safety">{{ 'header.services.workSafety' | translate }}</a></li>
          <li><a routerLink="/questions">{{ 'header.questions' | translate }}</a></li>
          <li><a routerLink="/contact">{{ 'header.contact' | translate }}</a></li>
          <li><a routerLink="/user-experiences">{{ 'footer.nav.userExperiences' | translate }}</a></li>
        </ul>
      </div>

      <!-- Column 3: Contact -->
      <div class="footer-col">
        <h2 class="footer-heading">{{ 'footer.contact.title' | translate }}</h2>
        <ul class="footer-contact-list">
          <li>
            <i class="fa-solid fa-location-dot"></i>
            <span>Gospodar Jovanova 39–41, Beograd</span>
          </li>
          <li>
            <i class="fa-solid fa-phone"></i>
            <span>+381 11 328 71 83</span>
          </li>
          <li>
            <i class="fa-solid fa-phone"></i>
            <span>+381 11 328 71 89</span>
          </li>
          <li>
            <i class="fa-solid fa-envelope"></i>
            <a href="mailto:kontakt@kontakta24.com">kontakt&#64;kontakta24.com</a>
          </li>
        </ul>
      </div>

      <!-- Column 4: Accreditation -->
      <div class="footer-col footer-accreditation-card">
        <h2 class="footer-heading">{{ 'footer.accreditation.title' | translate }}</h2>
        <p>{{ 'footer.accreditation.description' | translate }}</p>
      </div>

    </div>
  </div>

  <!-- Bottom bar -->
  <div class="footer-bottom">
    <div class="footer-bottom-inner">
      <span class="footer-copyright">
        {{ 'footer.copyright' | translate: { year: currentYear } }}
      </span>
      <ul class="footer-legal-links">
        <li><a routerLink="/privacy">{{ 'footer.legal.privacy' | translate }}</a></li>
        <li><a routerLink="/terms">{{ 'footer.legal.terms' | translate }}</a></li>
      </ul>
    </div>
  </div>
</footer>
